export default "__VITE_ASSET__Cw16JabR__"